import { AppThunk } from "../states/generateStore";
import snackBarSlice from '../states/snackbar/slice';
import { getDataLead, suiteCrmUrl } from "./constants";
import shellSlice from '../states/shell/slice';

// import { where_hear_us_options } from '../fields/customer/quoteSummaryField';
import { decode } from 'html-entities';
import onGetPricingOption from "./onGetPricingOption";

const onGetDataLead = (leadId: any): AppThunk =>
  async (dispatch, getStore) => {
    try {
      let formData = new FormData();
      formData.append('record_id', leadId);

      let response = await fetch(suiteCrmUrl.concat(getDataLead),
        { 
          method: 'POST',
          body: formData
        }
      );
      let result = await response.json();

      if (result) {
        // convert to Lead state
        dispatch(shellSlice.actions.updateLeadId(result.id[1]));

        // description Lead
        let description = result.description[1];
        let info_pack = result.issendinfopack_c[1] ? result.issendinfopack_c[1].indexOf('sanden') !== -1 ? "no" : "yes" : "no";
        let choice_type_install = "",
          product_choice_type = "",
          choice_type_product = "",
          note_select = "",
          customer_note = "";
        if ( description ) {
          // choice type install
          if (description.hasOwnProperty("How many phases")) {
            if (description["How many phases"] === "Single Phase") {
              choice_type_install = "d6095966-02f1-e8ac-42c9-619746789c89";
              dispatch(onGetPricingOption(choice_type_install));
            } else if (description["How many phases"] === "Three Phases") {
              choice_type_install = "e05a85fb-8a54-03ff-1f3e-6114a54151b7";
              dispatch(onGetPricingOption(choice_type_install));
            } else {
              choice_type_install = "";
            }
          }
          
          // choice type product, product choice type
          if (description.hasOwnProperty("Please select your current hot water service type")) {
            switch (description["Please select your current hot water service type"]) {
              case "Gas Instant":
                choice_type_product = "gas_type";
                product_choice_type = "gas_instant";
                break;
              case "Gas Storage":
                choice_type_product = "gas_type";
                product_choice_type = "gas_storage";
                break;
              case "Elec Storage":
                choice_type_product = "electric_type";
                product_choice_type = "electric_storage";
                break;
              case "Solar hot water storage":
                choice_type_product = "solar_type";
                break;
              default: break;
            }
          }

          // hear about us
          // if (description.hasOwnProperty("Where did you hear about us"))
          //   where_hear_us_options.forEach((item: any) => {
          //     if (description["Where did you hear about us"] === item.label)
          //       hear_about = item.value;
          //   });
          
          // customer note
          if (description.hasOwnProperty("Messages")) {
            note_select = "yes";
            customer_note = description["Messages"];
          }
        }
        
        // initial form value
        let initialValuePayload = getStore().shell.initialValues;
        initialValuePayload = {
          ...initialValuePayload,
          address: decode(result.billing_address_street[1]),
          full_address: decode(result.address[1]),
          locality: decode(result.billing_address_city[1]),
          state: decode(result.billing_address_state[1]),
          zip: decode(result.billing_address_postalcode[1]),
          your_email: decode(result.billing_account_email[1]),
          first_name: decode(result.first_name[1]),
          last_name: decode(result.last_name[1]),
          phone_number: result.mobile_phone_c[1],
          choice_type_install: choice_type_install,
          choice_type_product: choice_type_product,
          product_choice_type: product_choice_type,
          hear_about: decode(result.lead_source[1]),
          note_select: decode(note_select),
          customer_note: decode(customer_note),
          info_pack: info_pack,
        }
        dispatch(shellSlice.actions.updateInitialValues(initialValuePayload));

        // set useDataLead = true
        dispatch(shellSlice.actions.updateUseDataLead(true));

        // show success
        dispatch(snackBarSlice.actions.updateAlert({message: "Get data Lead success", severity: "success"}));
        dispatch(snackBarSlice.actions.updateSnackBar(true));
      } else {
        // show warning
        dispatch(snackBarSlice.actions.updateAlert({message: "Unable to get Lead data", severity: "warning"}));
        dispatch(snackBarSlice.actions.updateSnackBar(true));
      }
    } catch (err) {
      console.log(err);
      // show error
      dispatch(snackBarSlice.actions.updateAlert({message: "onGetDataLead: Can not get data from Server", severity: "error"}));
      dispatch(snackBarSlice.actions.updateSnackBar(true));
    }
  }

export default onGetDataLead;